export const PIXEL_RATIO = window.devicePixelRatio || 1;
export const VIEWPORT_RATIO = 0.98;
export const ZONE_DEFAULT_HEIGHT = 50;
export const ZONE_DEFAULT_WIDTH = 180;
export const ZONE_MIN_HEIGHT = 40;
export const ZONE_MIN_WIDTH = 100;
export const ZONE_TEXT_DEFAULT_HEIGHT = 20;
export const ZONE_TEXT_DEFAULT_WIDTH = 180;
export const ZONE_TEXT_MIN_HEIGHT = 20;
export const ZONE_TEXT_MIN_WIDTH = 50;
export const ZONE_INITIALS_DEFAULT_HEIGHT = 20;
export const ZONE_INITIALS_DEFAULT_WIDTH = 40;
export const ZONE_INITIALS_TRIGGER_HEIGHT = 24;
export const ZONE_INITIALS_TRIGGER_WIDTH = 88;
export const ZONE_ICON_MIN_WIDTH = 24;
export const ZONE_ICON_MAX_WIDTH = 144;
